export default __webpack_public_path__ + "static/media/hero.7fbf2410.webp";